import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SERVER_API_URL } from 'src/app/app.constants';
import { createRequestOption } from 'src/app/shared/util/request-util';
import {
    CertificateTradeDetails,
    CertifiCargoDetails,
    CertifiShipmentDetails,
    CertificateRequestDto
} from 'src/app/shared/model/certificate-trade-details.model';
import { CertificateFilterPagination } from 'src/app/shared/model/certificate-filter-pagination.model';

type EntityResponseType = HttpResponse<CertificateRequestDto>;
type EntityArrayResponseType = HttpResponse<CertificateRequestDto[]>;

@Injectable({ providedIn: 'root' })
export class MyCertificateService {
    private resourceCertificatesUrl = SERVER_API_URL + 'api/certificates';
     private spotResourceCertificatesUrl = SERVER_API_URL + 'api/spot-certificates';

    constructor(private http: HttpClient) {}

    query(req?: any): Observable<any> {
        const options = createRequestOption(req);
        return this.http.get<any[]>(this.resourceCertificatesUrl, { params: options, observe: 'response' });
    }
    queryWithFilter(req?: CertificateFilterPagination): Observable<any> {
       // const options = createRequestOption(req);
        return this.http.post<any[]>(this.resourceCertificatesUrl, req, {  observe: 'response' });
    }

    queryWithStatus(req?: any, status?: any): Observable<any> {
        const options = createRequestOption(req);
        let withStaus =  this.resourceCertificatesUrl +'-with-status';
        return this.http.put<any[]>(withStaus,status, { params: options, observe: 'response' });
    }

    spotQuery(req?: any): Observable<any> {
        const options = createRequestOption(req);
        return this.http.get<any[]>(this.spotResourceCertificatesUrl, { params: options, observe: 'response' });
    }

    queryWithUrl(url?: any, req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        const URL = this.resourceCertificatesUrl + url;
        return this.http.get<any[]>(URL, { params: options, observe: 'response' });
    }

    queryWithURL(url?: string): Observable<HttpResponse<Blob>> {
        return    this.http.get(url ,{ observe: 'response', responseType: 'blob'});
    }

    searchQuery(searchKey?: string, url?: string, req?: any ,  status?: any): Observable<HttpResponse<any[]>> {
        // const options = createRequestOption(req);
        searchKey = searchKey.trim().replace('+', '');
        searchKey = encodeURI(searchKey);
        return this.http.put<any[]>(this.resourceCertificatesUrl + url + '?searchKey=' + searchKey, status, { params: req, observe: 'response' });
    }
    queryBlobObject(url:string, req?: CertificateFilterPagination): Observable<HttpEvent<Blob>> {
        const _url = SERVER_API_URL + url;
        return this.http.post(_url,req , { responseType: 'blob', observe: 'events' }).map(blob => {
            // window.open(_url);
            return blob;
        });
    }

    
}
